import React from 'react';
import { Link } from 'react-router-dom';
import './style/UserCreationModal.css';

function UserCreationModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  const handleCreateEntity = () => {
    // Здесь может быть код для создания сущности
    onClose(); // Закрывает модальное окно после создания сущности
  };

  const handleCreateLegalEntity = () => {
    onClose(); // Закрывает модальное окно при переходе по ссылке
};

return (
  <div className="usercm-modal-overlay" onClick={onClose}>
    <div className="usercm-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="usercm-close-button" onClick={onClose}>
          ×
        </button>
        <h2 className="usercm-modal-title">Создать пользователя</h2>
      <div className="usercm-button-group">
        <Link to="/CreatingUserYuridicheskoyeLitso" className="usercm-CreatingUserYuridicheskoyeLitso" onClick={handleCreateLegalEntity}>
          <button className="usercm-submit-button">
            Регистрация юридического лица
          </button>
        </Link>
        <Link to="/CreatingUserFizicheskoyeLitso" className="usercm-CreatingUserFizicheskoyeLitso" onClick={handleCreateLegalEntity}>
          <button className="usercm-submit-button" onClick={handleCreateEntity}>
            Регистрация физического лица
          </button>
        </Link>
      </div>
    </div>
  </div>
);
}

export default UserCreationModal;
